.rail {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: var(--tempest-space-2);
    width: 80px;
    height: 100%;
    padding: var(--tempest-space-3) var(--tempest-space-2);
    background: var(--tempest-surface);
    border-right: 1px solid var(--tempest-border);
    font-family: var(--tempest-font-sans);
}

.header {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin-bottom: var(--tempest-space-2);
}

.list {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: var(--tempest-space-1);
    width: 100%;
    margin: 0;
    padding: 0;
    list-style: none;
}

.footer {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin-top: auto;
    padding-top: var(--tempest-space-2);
}

.item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    width: 100%;
    padding: var(--tempest-space-2) var(--tempest-space-1);
    background: none;
    border: 0;
    border-radius: var(--tempest-radius-md);
    cursor: pointer;
    color: var(--tempest-text-muted);
    font-size: var(--tempest-text-2xs);
    transition:
        color var(--tempest-duration-fast, 120ms) var(--tempest-ease-out, ease-out),
        background var(--tempest-duration-fast, 120ms) var(--tempest-ease-out, ease-out);
}

.item:hover {
    color: var(--tempest-text);
    background: var(--tempest-surface-2);
}

.item:focus-visible {
    outline: var(--tempest-focus-ring-width, 2px) solid
        var(--tempest-focus-ring-color, var(--tempest-primary));
    outline-offset: var(--tempest-focus-ring-offset, 2px);
}

.item.active {
    color: var(--tempest-primary-on-soft);
    background: var(--tempest-primary-soft);
}

.item:disabled {
    opacity: 0.4;
    cursor: not-allowed;
}

.iconWrap {
    position: relative;
    display: inline-flex;
}

.icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
    font-size: 24px;
}

.badge {
    position: absolute;
    top: -4px;
    right: -8px;
    min-width: 14px;
    height: 14px;
    padding: 0 4px;
    border-radius: var(--tempest-radius-full);
    background: var(--tempest-danger-solid);
    color: var(--tempest-danger-on-solid);
    font-size: 10px;
    line-height: 14px;
    text-align: center;
    font-weight: var(--tempest-weight-semibold);
}

.label {
    line-height: 1;
    text-align: center;
}
